// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-FormBuilder-ResetAllWarningDialog-module__modalFooter";
export { _1 as "modalFooter" }
